export const PayTo = Object.freeze({
  INSTALAB: "instalab",
  FACILITY: "facility",
  INSURANCE: "insurance",
  MIXED: "mixed",
})  

export default PayTo